import { doc, updateDoc } from 'firebase/firestore';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { db, storage } from '../../../shared/storage/firebase';

export class ClassroomAvatarService {
  static async upload(squadId: string, scope: 'squad' | string, file: File): Promise<string> {
    if (!file.type.startsWith('image/')) throw new Error('Choose an image file.');
    if (file.size > 15 * 1024 * 1024) throw new Error('Choose an image smaller than 15 MB.');
    const ext = (file.name.split('.').pop() || 'jpg').replace(/[^a-z0-9]/gi, '').toLowerCase();
    const path = `squads/${squadId}/portfolios/avatars/${scope}/${Date.now()}.${ext}`;
    const target = ref(storage, path);
    await uploadBytes(target, file, { contentType: file.type });
    return getDownloadURL(target);
  }
  static setSquad(squadId: string, url: string, kind: 'muse'|'upload') {
    return updateDoc(doc(db, 'squads', squadId), { classroomAvatarUrl: url, classroomAvatarKind: kind, updatedAt: Date.now() });
  }
  static setTeam(squadId: string, teamId: string, url: string, kind: 'muse'|'upload') {
    return updateDoc(doc(db, 'squads', squadId, 'teams', teamId), { avatarUrl: url, avatarKind: kind, updatedAt: Date.now() });
  }
  static setStudent(squadId: string, studentId: string, url: string, kind: 'muse'|'upload') {
    return updateDoc(doc(db, 'users', studentId), {
      classroomAvatarUrl: url,
      classroomAvatarKind: kind,
      _lastClassroomAvatarContext: { squadId, updatedAt: Date.now() },
    });
  }
}
